import { notificationApi } from '@sinups/ui-kit';
import { useState, useEffect } from 'react';

interface InfiniteLoaderProps {
  initialCount?: number;
}

export function useUnreadNotificationsLoader({ initialCount = 10 }: InfiniteLoaderProps) {
  const [offset, setOffset] = useState(0);
  const [count] = useState(initialCount);
  const [hasMore, setHasMore] = useState(true);

  const { data, isFetching, isLoading, refetch } = notificationApi.useGetUnreadNotificationsQuery(
    {
      count,
      offset,
      isAll: true
    },
    {
      refetchOnMountOrArgChange: true
    }
  );

  useEffect(() => {
    if (data?.count) {
      if (data.count < count) {
        setHasMore(false);
      }
    }
  }, [data?.notifications, count]);

  const loadMore = () => {
    if (!isFetching && !isLoading && hasMore) {
      setOffset((prev) => prev + count);
    }
  };

  return {
    loadMore,
    isLoading: isFetching || isLoading,
    hasMore,
    refetch,
    notifications: data?.notifications ?? [],
    lastSeenAt: data?.lastSeenAt ?? '',
    unreadCount: data?.unreadCount
  };
}
